document.querySelectorAll('a[href*="#"]').forEach(anchor => {

  if(anchor.parentNode.classList.contains('active')) {
    anchor.parentNode.classList.remove('active');
  }

  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const id = this.hash;
    const target = document.querySelector(id);

    if(target) {
      window.history.replaceState({}, "", id);
      const y = target.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({top: y, behavior: 'smooth'});
    } else {
      window.location.href = this.href;
    }

  });
});
